// LeadActivity.jsx

import React from "react";
import Button from "../ui/Button";
import { ArrowLeft } from "lucide-react";

  import { formatDateTime } from "../../hooks/commonHooks";

import { useNavigate } from "react-router-dom";

import {
  Flame,
  MapPin,
  IndianRupee,
  Activity,
  Clock3,
  MessageSquare,
  Building2,
  Eye,
} from "lucide-react";

import Card from "../ui/Card";
import SectionCard from "../ui/SectionCard";
import ScoreBadge from "./ScoreBadge";
import StatCard from "../ui/StatCard";

import { formatDuration } from "../../hooks/activityCalulations";

import PageContainer from "../common/PageContainer";

import {
  generateLeadAnalytics,
} from "../../hooks/activityCalulations";

import { useLeadStore } from "../../store/leadStore";

import { useAuthStore } from "../../store/authStore";

import LeadBasicInfo from "./LeadBasicInfo";

import "../../styles/lead_activity.css";

export default function LeadActivity() {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";
  const navigate = useNavigate();
  if(!isAdmin){
    return null;
  }
  /**
   * -----------------------------------------
   * STORE
   * -----------------------------------------
   */

  const { selectedLead } =
    useLeadStore();
  console.log("🚀 ~ LeadActivity ~ selectedLead:", selectedLead)
  const activitySummary = selectedLead?.activity_summary ?? "No activity summary available";
  console.log("🚀 ~ LeadActivity ~ activitySummary:", activitySummary)

  /**
   * -----------------------------------------
   * ANALYTICS
   * -----------------------------------------
   */

  const analytics =
    generateLeadAnalytics(
      selectedLead?.chat_activity ||
        []
    );
  console.log("🚀 ~ LeadActivity ~ analytics:", analytics)

  /**
   * -----------------------------------------
   * HELPERS
   * -----------------------------------------
   */

  const formatBudget = (
    budget
  ) => {
    if (!budget)
      return "Not Selected";

    return `₹${budget.min.toLocaleString()} - ₹${budget.max.toLocaleString()}`;
  };

  const leadTemperatureClass =
  selectedLead?.category?.toLowerCase() === "hot"
      ? "hot-lead"
      : selectedLead?.category?.toLowerCase() === "warm"
      ? "warm-lead"
      : selectedLead?.category?.toLowerCase() === "cold"
      ? "cold-lead"
      : "";

    console.log("🚀 ~ LeadActivity ~ leadTemperatureClass :", leadTemperatureClass )


  return (
    <PageContainer>

      <div className="lead-activity-page d-flex flex-column gap-2 mx-auto w-100">
      <div className="d-flex align-center mb-2">
      <Button
        variant="outline"
        className="d-flex align-center gap-2 btn-md"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={18} />
        Back
      </Button>
      </div>
          <LeadBasicInfo />

          {/* -------------------------------- */}
          {/* ACTIVITY SUMMARY */}
          {/* -------------------------------- */}

          <Card className="mx-0 mb-4 mxrounded-20 p-3 max-w-none card-shadow hover-lift position-relative overflow-hidden max">
            <div className="d-flex justify-between align-center gap-2 mb-3 flex-wrap">
              <div>
                <p className="text-xs text-muted fw-semibold m-0 mb-1">
                  LEAD ACTIVITY SUMMARY
                </p>

                <h2 className="text-lg text-primary fw-bold m-0">
                  AI Behavioral Insights
                </h2>
              </div>
            </div>

            <div
              className="
                text-md
                text-slate-600
                lh-14
                whitespace-pre-line
              "
            >
              {activitySummary}
            </div>
        </Card>


        <div className="page-header mb-3">
          <div>
            <h1 className="m-0">
              Lead Activity
              Analytics
            </h1>

            <h4 className="text-muted mt-1 m-0">
              Buyer behavior,
              engagement, and
              property interest
              insights
            </h4>
          </div>
        </div>

        {/* -------------------------------- */}
        {/* TOP KPI GRID */}
        {/* -------------------------------- */}

        <div className="grid-auto-fit mb-4">
          <StatCard title="Lead Score" value={<ScoreBadge score={selectedLead?.score} />} icon={<Flame size={20} />} valueColorClass={leadTemperatureClass} />
          <StatCard title="Preferred Location" value={selectedLead?.location} icon={<MapPin size={20} />} />
          <StatCard title="Final Budget" value={formatBudget(analytics.buyerIntent?.finalBudget)} icon={<IndianRupee size={20} />} />
          <StatCard title="Chat Widget Duration" value={analytics.session?.duration || "N/A"} icon={<Clock3 size={20} />} />
        </div>
        {/* -------------------------------- */}
        {/* ENGAGEMENT */}
        {/* -------------------------------- */}
        <SectionCard
          title="Engagement Overview"
          className="mb-4"
        >
          <div className="grid-auto-fit">
            <StatCard title="Chat Time" value={formatDuration(analytics.engagement?.totalChatTime)} icon={<MessageSquare size={20} />} />
            <StatCard title="Projects Time" value={formatDuration(analytics.engagement?.totalProjectsTime)} icon={<Building2 size={20} />} />
            <StatCard title="Dominant View" value={analytics.engagement?.dominantView} icon={<Activity size={20} />} />
            <StatCard title="Properties Viewed" value={analytics.summary?.viewedProperties} icon={<Eye size={20} />} />
          </div>
        </SectionCard>

        {/* -------------------------------- */}
        {/* PROPERTY INTEREST */}
        {/* -------------------------------- */}
        <SectionCard title="Property Interest p-0">
            <div className="grid-auto-fit">
              {analytics.propertyInterest.map((property, index) => (
                <Card
                  key={index}
                  className="property-card hover-lift m-0"
                >
                  {/* Property Name */}
                  <div className="mb-3">
                    <h3 className="property-title m-0">
                      {property.property}
                    </h3>
                  </div>

                  {/* Simple divider for structure */}
                  <div className="divider mb-3" />

                  {/* Viewed At */}
                  <div className="d-flex align-center justify-between">
                    <span className="text-sm text-muted">
                      Viewed At
                    </span>

                    <span className="text-sm text-primary font-medium">
                      {formatDateTime(
                        property.viewedAt,
                        "dd/MM/yyyy HH:mm"
                      )}
                    </span>
                  </div>
                </Card>
              ))}
            </div>
  </SectionCard>
      </div>
    </PageContainer>
  );
}